"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Prowhip() {
  const [loaded, setLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  const headline1 = "Experience ProWhip";
  const headline2 = "Excellence.";
  return <section data-section-id="3858" id="prowhip-excellence-hero" className="relative min-h-screen w-full overflow-hidden bg-white text-black bg-cover bg-[position:70%_center] !bg-[url(https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-7-2026-12_26_52-PM.png)] !bg-[url(https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-7-2026-12_56_17-PM.png)]">
      {}
      <div className="absolute inset-0 z-0" style={{
      transform: `scale(${1 + Math.min(scrollY, 600) / 6000})`,
      transition: "transform 0.1s linear"
    }}>
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-10" style={{
      background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 z-10 opacity-[0.05] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      {}
      <div className="absolute right-6 top-1/2 z-20 hidden -translate-y-1/2 md:block lg:right-10">
        <div className="font-default text-[11px] uppercase tracking-[0.3em] text-white/70" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          — ProWhip / Culinary Innovation
        </div>
      </div>

      {}
      <div className="relative z-20 flex min-h-screen w-full flex-col">
        {}
        

        <div className="w-full px-6 pb-16 sm:px-10 md:pb-20 lg:px-16 lg:pb-24">
          <div className="max-w-3xl text-center md:text-left">
            {}
            <div className={`mb-6 flex items-center justify-center gap-4 transition-all duration-1000 md:justify-start ${loaded ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
              <span className="block h-px w-10 bg-[#e63946]" />
              <span className="font-default text-[11px] uppercase tracking-[0.25em] text-white/80">
                Premium Cream Chargers · Culinary Grade
              </span>
            </div>

            {}
            <h1 className="font-default font-bold leading-[0.95] text-white" style={{
            fontSize: "clamp(3.5rem, 9vw, 6rem)"
          }}>
              <span className="block overflow-hidden">Tasty</span>
              <span className="block overflow-hidden text-[#e63946]">Infusions</span>
            </h1>

            {}
            <p className={`mt-8 max-w-xl text-lg font-default leading-relaxed text-white/75 transition-all duration-1000 sm:text-xl md:mx-0 mx-auto ${loaded ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDelay: "1400ms"
          }}>
              Premium cream chargers designed for professional culinary innovation and precision.
            </p>

            {}
            <div className={`mt-10 flex flex-col items-center gap-5 transition-all duration-1000 sm:flex-row md:items-start ${loaded ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDelay: "1600ms"
          }}>
              <Link to="/InquiryPage">
                <Button className="group h-14 rounded-lg bg-[#e63946] px-8 font-default text-base font-semibold text-white transition-all duration-300 hover:bg-[#c62828]">
                  Inquire Now
                  <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-6 z-20 hidden flex-col items-center gap-3 md:flex lg:right-10">
        <span className="font-default text-[10px] uppercase tracking-[0.3em] text-white/60">
          Scroll
        </span>
        <div className="relative h-12 w-px overflow-hidden bg-white/20">
          <span className="absolute left-1/2 top-0 block size-1.5 -translate-x-1/2 rounded-lg bg-[#e63946]" style={{
          animation: "echoScrollDot 3s ease-in-out infinite"
        }} />
        </div>
      </div>

      <style>{`
        @keyframes echoScrollDot {
          0% { transform: translate(-50%, -100%); opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 1; }
          100% { transform: translate(-50%, 48px); opacity: 0; }
        }
      `}</style>
    </section>;
}